import { useEffect } from "react";

const SITE_NAME       = "The Rough Cut";
const SITE_FULL_TITLE = "The Rough Cut — Independent Indie Game Criticism";
const SITE_DESC       = "Independent indie game criticism. Honest reviews, hidden gem spotlights, and unfiltered opinions. No paid promotions.";
const SITE_URL        = window.location.origin;

function setTag(attrKey, attrVal, content) {
  let el = document.querySelector(`meta[${attrKey}="${attrVal}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrKey, attrVal);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

const name = (n, v) => setTag("name",     n, v);
const og   = (p, v) => setTag("property", p, v);

function removeArticleTags() {
  ["article:published_time", "article:modified_time", "article:author", "article:section"].forEach(prop => {
    document.querySelector(`meta[property="${prop}"]`)?.remove();
  });
  document.querySelectorAll('meta[property="article:tag"]').forEach(el => el.remove());
}

export default function useMeta({ title, description, image, type = "website", noIndex = false, article = null } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_FULL_TITLE;
    const desc      = description ? description.slice(0, 160) : SITE_DESC;
    const url       = window.location.href;

    document.title = fullTitle;

    // Canonical link
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    // Standard meta
    name("description", desc);
    name("robots",      noIndex ? "noindex, nofollow" : "index, follow");

    // Open Graph
    og("og:title",       fullTitle);
    og("og:description", desc);
    og("og:type",        type);
    og("og:url",         url);
    if (image) og("og:image", image);

    // Twitter Card
    name("twitter:card",        image ? "summary_large_image" : "summary");
    name("twitter:title",       fullTitle);
    name("twitter:description", desc);
    if (image) name("twitter:image", image);

    // Article-specific Open Graph
    if (type === "article" && article) {
      if (article.published_time) og("article:published_time", article.published_time);
      if (article.modified_time)  og("article:modified_time",  article.modified_time);
      if (article.author)         og("article:author",         article.author);
      if (article.section)        og("article:section",        article.section);
      document.querySelectorAll('meta[property="article:tag"]').forEach(el => el.remove());
      (article.tags || []).forEach(tag => {
        const el = document.createElement("meta");
        el.setAttribute("property", "article:tag");
        el.setAttribute("content", tag);
        document.head.appendChild(el);
      });
    } else {
      removeArticleTags();
    }

    return () => {
      document.title = SITE_FULL_TITLE;
      name("description", SITE_DESC);
      name("robots",      "index, follow");
      og("og:title",       SITE_FULL_TITLE);
      og("og:description", SITE_DESC);
      og("og:type",        "website");
      og("og:url",         SITE_URL);
      const el = document.querySelector("link[rel='canonical']");
      if (el) el.setAttribute("href", SITE_URL);
      removeArticleTags();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, image, type, noIndex, JSON.stringify(article)]);
}
